import { Injectable, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { map } from 'rxjs/operators';
import { urlConfig } from '../shared/constants/url-config';
import { FieldConfig } from '../shared/dynamicform/models/common-models';
import { AuthorizeIFrameInfoDTO, ContactDTO, FinancialEffectForUpdatedReservationDTO, NewPartyDetailsDTO, RegisterReservationAttemptResponseDTO, ReservationAttemptBasicInfo, ReservationInfoDTO, SecondaryContactDTO } from '../shared/Models/PartyModels';
import { PayloadOperationResultDTO } from '../shared/Models/ResultModels';
import { SlotLockResultDTO } from '../shared/Models/SlotLockModels';
import { WidgetSettingsDTO } from '../shared/Models/WidgetSettingsModels';
import { HttpService } from '../shared/services/http.service';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ReservationService {
  restaurantName:string;
  reservationFormGroup:UntypedFormGroup;
  reservationConfimationDetails: NewPartyDetailsDTO;
  isDeferredPaymentMode:boolean=false;
  reservationAttemptInfo:RegisterReservationAttemptResponseDTO;
  additionalGuestPage:boolean = false;
  ispaymentInvolvedInfo:ReservationInfoDTO;
  additionalGuestRequired:number=0;
  selectedCountryId:number;
  showPaymentSummary=false;
  reservationConfirmationText='';
  primaryContact:ContactDTO;
  secondaryContactList:SecondaryContactDTO[];
  lockCallRequired = false;
  selectedSpecialMealId$:BehaviorSubject<number> = new BehaviorSubject<number>(null);
  constructor(private httpService: HttpService, private fb:UntypedFormBuilder) {
    this.reservationFormGroup = this.fb.group({
    })

  }

  // getSpecialMeal(restaurantName:string) {
  //  return this.httpService.get(urlConfig.getWidgetSettings + 'Blue-Beach-Cabanas-xxx').pipe(
  //   map((data: any) => data.Payload as WidgetSettingsDTO));
  // }

  getLayoutData(restaurantId:Number,partySize:Number,isCommunalTable:boolean,timeSlot,seatingAreaId=null,seatingTypeId=null,reservationIdToIgnore=null , eventId:number = null) {
    seatingTypeId = null;
    return this.httpService.get(`${urlConfig.layoutUrl}?restaurantId=${restaurantId}&timeSlot=${timeSlot}&partySize=${partySize}&showCommunalTable=${isCommunalTable}&seatingareaid=${seatingAreaId}&reservationIdToIgnore=${reservationIdToIgnore}&seatingtypeid=${seatingTypeId}&eventId=${eventId}`);
   }

   
  getOpenBookingLayoutData(reqObj: any) {
    return this.httpService.post(`${urlConfig.openBookingLayoutUrl}`, reqObj);
   }

   getLayoutBackgroundImage(restaurantId:Number){
     return this.httpService.get(urlConfig.layoutImageUrl +restaurantId)
   }

   getOpenBookingAddOns(reqObj: any, specialMealId: number) {
    return this.httpService.post(`${urlConfig.openBookingAddOnsUrl}?specialMealId=${specialMealId}`, reqObj);
   }


   GetRestaurantDateAvailability(restaurantId:Number,partySize:Number,isCommunalTable:boolean,fromWidget:boolean,date,seatingAreaId=null,reservationIdToIgnore=null,specialMealId=null,seatingTypeId=null){

    // return this.httpService.get(urlConfig.dateAvailabilityUrl+
    // '?restaurantId='+restaurantId+
    // &date=${date}
    // &partySize=${partySize}
    // &isCommunalTable=${isCommunalTable}
    // &fromWidget=${fromWidget}
    // &seatingAreaId=${seatingAreaId}
    // &reservationIdToIgnore=${reservationIdToIgnore}
    // &specialMealId=${specialMealId}
    // &seatingTypeId=${seatingTypeId}`);

    return this.httpService.get(`${urlConfig.dateAvailabilityUrl}?restaurantId=${restaurantId}&date=${date}&partySize=${partySize}&isCommunalTable=${isCommunalTable}&fromWidget=${fromWidget}&seatingAreaId=${seatingAreaId}&reservationIdToIgnore=${reservationIdToIgnore}&specialMealId=${specialMealId}&seatingTypeId=${seatingTypeId}`).pipe(map((data:any)=> data.Payload));
   }

   GetLockSlot(restaurantId,lockSlotDto){
    return this.httpService.post(urlConfig.acquireLock +'?restaurantId='+restaurantId,lockSlotDto).pipe(
      map((data: any) => ((data as PayloadOperationResultDTO).Payload as SlotLockResultDTO)
        //data.Payload as SlotLockResultDTO;
      ));
   }

   GetRegisterReservationAttempt(reservationAttemptId:Number){
    return this.httpService.get(`${urlConfig.getReservationAttemptState}?reservationAttemptId=${reservationAttemptId}`).pipe(map((data:any) =>data.Payload as ReservationAttemptBasicInfo));
   }

    GetRestaurantAvailableDates(restaurantId:Number,partySize:Number,date,seatingAreaId=null,reservationIdToIgnore=null,specialMealId=null,seatingTypeId=null){
    seatingTypeId = seatingTypeId &&  seatingTypeId > 0 ? seatingTypeId : null;
    return this.httpService.get(`${urlConfig.availableDateUrl}?restaurantId=${restaurantId}&date=${date}&partySize=${partySize}&seatingAreaId=${seatingAreaId}&reservationIdToIgnore=${reservationIdToIgnore}&specialMealId=${specialMealId}&seatingTypeId=${seatingTypeId}`).pipe(map((data:any)=> data.Payload));
   }



   GetCustomFields(restaurantId:Number){
     return this.httpService.get(`${urlConfig.getCustomGuestFields}?restaurantId=${restaurantId}`);
   }


  ReleaseLockSlot(restaurantId:Number,lockId:Number){
    return this.httpService.post(`${urlConfig.releaseLock}?restaurantId=${restaurantId}&lockId=${lockId}`);
  }

  GetPreliminaryReservationInformation(restaurantId: Number, partySize: Number, date, specialMealId = null, tableId = null, seatingAreaId = null,seatingTypeId=null){
    seatingTypeId = null;
    return this.httpService.get(`${urlConfig.getPreliminaryReservationInformation}?restaurantId=${restaurantId}&localDateTime=${date}&partySize=${partySize}&specialMealId=${specialMealId}&tableId=${tableId}&seatingAreaId=${seatingAreaId}&seatingTypeId=${seatingTypeId}`).pipe(map((data:any)=> data.Payload as ReservationInfoDTO));
  }

  GetCoverTypePricing(restaurantId:Number,specialMealId:Number){
    return this.httpService.get(`${urlConfig.getCoverTypePricing}?restaurantId=${restaurantId}&specialMealId=${specialMealId}`);
  }

  CreateReservation(restaurantId:Number,reservationDTO, overlapBooking: boolean = false){
    return this.httpService.post(urlConfig.createReservation +'?restaurantId='+restaurantId + `&allowOverlapBookings=${overlapBooking}&languageId=${sessionStorage.getItem('languageId')}`,reservationDTO ).pipe(map((data:any)=> data.Payload as NewPartyDetailsDTO))
  }

  UpdateReservation(restaurantId:Number,reservationDTO, overlapBooking: boolean = false){
    return this.httpService.post(urlConfig.updateReservation +'?restaurantId='+restaurantId + `&allowOverlapBookings=${overlapBooking}&languageId=${sessionStorage.getItem('languageId')}`,reservationDTO).pipe(map((data:any)=> data.Payload as NewPartyDetailsDTO))
  }

  CancelReservation(restaurantId:Number,partyId:Number,language:Number){
    return this.httpService.post(`${urlConfig.cancelReservation}?restaurantId=${restaurantId}&partyId=${partyId}&language=${language}`);
  }

  RegisterReservationAttempt(restaurantId:Number,RegisterReservationAttemptRequestDTO){
    return this.httpService.post(urlConfig.registerReservationAttempt +'?restaurantId='+restaurantId,RegisterReservationAttemptRequestDTO).pipe(map((data:any)=> data.Payload as RegisterReservationAttemptResponseDTO))
  }

  UpdateReservationAttempt(PaymentCallbackRequest){
    return this.httpService.post(urlConfig.updateReservationAttempt,PaymentCallbackRequest)
  }

  GetFinancialEffectCalculation(restaurantId:Number,reservationDTO){
    return this.httpService.post(urlConfig.getFinancialEffectForUpdatedReservationDTO +'?restaurantId='+restaurantId,reservationDTO).pipe(map((data:any)=>data.Payload as FinancialEffectForUpdatedReservationDTO));
  }

  GetAuthWaiverForm(restaurantId:Number,formCode:string){
    return this.httpService.get(urlConfig.getAuthWaiverForm +'?restaurantId='+restaurantId + '&formCode=' + formCode).pipe(
      map((data:any) => data.Payload as AuthorizeIFrameInfoDTO)
    );
  }

  CreateSecondaryContacts(restaurantId:Number,partyId:Number,contactList){
    return this.httpService.post(urlConfig.createSecondaryContacts + '?restaurantId='+restaurantId+'&partyId='+partyId,contactList).pipe(
      map((data:any)=>data.Payload as Number)
    );
  }
  /** 🐞 Bug Fix | Issue: 65228 | Root: versa has more than one booking with same confirmationCode  | Fix: filter result set from versa response by arrival date | By: Mahalakshmi Kalidas | Date: 2026-08-25 */
  getBookingTypesDetails(restaurantId : Number , memberId: string , bookingGuestTypes : Number, activityId: number, arrivalDate: string) {
    return this.httpService.post(`${urlConfig.SearchByBookingType}?restaurantId=${restaurantId}&inputstring=${memberId}&bookingGuestTypes=${bookingGuestTypes}&activityId=${activityId}&arrivalDate=${arrivalDate}`).pipe(map((data:any)=>data.Payload ));
  }

  wildSearchEngageMember(searchTerm, restaurantId: number) {
    return this.httpService.post(`${urlConfig.WildSearchEngageMemberURL}?restaurantId=${restaurantId}&searchTerm=${searchTerm}`)
  }
  
  getLocationRateplanCalculated(restaurantId, request){
    return this.httpService.post(`${urlConfig.getRateplan}?restaurantId=${restaurantId}`, request).pipe(map(({Payload: data})=>{
      //Charge Split is for Single Guest and Single Slot with duration.
      let _rawRateSplit = data.RatePlan.Reservations[0].Sessions[0].GuestPrices[0];
      let _chargeSplit = {
        Items: _rawRateSplit.Items,
        GuestPrices: data.RatePlan.Reservations[0].Sessions[0].GuestPrices,
        ServiceCharge: data.RatePlan.Reservations[0].ServiceCharge,
        SubTotal:data.RatePlan.Reservations[0].SubTotal,
        Tax: data.RatePlan.Reservations[0].Tax,
        TaxOnServiceChargeAmount: data.RatePlan.Reservations[0].TaxOnServiceChargeAmount,
        Total: data.RatePlan.Reservations[0].Total,
        VAT: data.RatePlan.Reservations[0].VAT,
        VATOnServiceChargeAmount: data.RatePlan.Reservations[0].VATOnServiceChargeAmount
      }
      return _chargeSplit;
    } ));
  }
}
